import React, {useState, useRef, useEffect} from "react";
import "./sections.scss";
import SwiperId from "react-id-swiper";
import {getPollWithUid_api, pollAnswer_api} from "../../../Services/apis";
import SimpleLineIcon from "react-simple-line-icons";

const imageParamss = {
    slidesPerView: '1',
    spaceBetween: 50,
    rtl: false,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
}

async function getPoll(id) {
    try {
        const res = await getPollWithUid_api(id)
    } catch (e) {
        console.log(e)
    }
}



function PollLastSlide({donePolls,p,select}){

    const [selected, set_selected] = useState({});

    return(
        <div className="swiper-card-body poll-card">
            <div className="poll-container">
                <div style={{marginTop:100}}>
                    <h5>از مشارکت شما در نظرسنجی سپاسگذاریم</h5>
                </div>
            </div>
        </div>
    )
}



function PollSlide({donePolls,p,select}){

    const [selected, set_selected] = useState({});
    const [lock, set_lock] = useState(false);

    useEffect(()=>{
        let find = donePolls.find(d=>d.uid===p.uid)
        if(find)
            set_lock(true)
        else
            set_lock(false)

    },[donePolls])

    useEffect(()=>{
        p.items.forEach(i=>{
            if(i.is_selected){
                set_selected(i)
                set_lock(true)
            }
        })
    },[])

    return(
        <div className="swiper-card-body poll-card">
        <div className="poll-container">
            <div className="poll-card-title">
                <span>{p.title}</span>
            </div>
            <div className="poll-card-list">
                {p.items.map(item=>{
                    return(
                        <div className={selected.uid===item.uid?"poll-card-item poll-card-item-active":"poll-card-item"}  onClick={()=>{
                            if(!lock){
                                set_selected(item)
                                select(item)
                            }

                        }}>
                            <span>{item.title}</span>
                        </div>
                    )
                })}
            </div>
        </div>
        </div>
    )
}


function PollStarSlide({donePolls,p,select}){

    const [selected, set_selected] = useState({});
    const [lock, set_lock] = useState(false);

    useEffect(()=>{
        let find = donePolls.find(d=>d.uid===p.uid)
        if(find)
            set_lock(true)
        else
            set_lock(false)

    },[donePolls])

    useEffect(()=>{
        p.items.forEach(i=>{
            if(i.is_selected){
                set_selected(i)
                set_lock(true)
            }
        })
    },[])


    const checkSelected = (selItemId,itemId,index)=>{
        let find   = p.items.findIndex(poll => poll.uid ===selected.uid);
        return find>index
    }

    return(
        <div className="swiper-card-body poll-card">
            <div className="poll-container">
                <div className="poll-card-title">
                    <span>{p.title}</span>
                </div>
                <div className="poll-star-card-list">
                    {p.items.map((item,i)=>{
                        return(
                            // <div>
                            //     <SimpleLineIcon name="star" />
                            // </div>

                            <div className={selected.uid===item.uid  || checkSelected(selected.uid,item.uid,i)?"poll-card-star-item poll-card-star-item-active":"poll-card-star-item"}  onClick={()=>{
                                if(!lock){
                                    set_selected(item)
                                    select(item)
                                }
                            }}>
                                <SimpleLineIcon name="star" />
                                <span>{i+1}</span>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}


function RateStarItem({set,star,select}){

    return(
        <div
            className="rateStarItem"
            onMouseOver={()=>{set(star.id);}}
            onClick={()=>select(star)}
        >
            {star.status?<SimpleLineIcon name="star" color={"#FFDD6F"}/>:<SimpleLineIcon name="star"/>}
        </div>
    )
}





function PollSec({item}) {

    const ref = useRef(null);
    const [swiper, setSwiper] = useState(null);
    const [polls, set_polls] = useState(null);




    useEffect(() => {
        console.log("poll", item.items)
        getAllPoll(item.items)
        return ()=>{
            console.log("exit ... ")
        }
    }, [])

    const getAllPoll = async (items) => {
        let poolsResponse = await Promise.all(items.map(async (p) => {
            return await getPollWithUid_api(p.link_to_uid)
        }));


        let poolObj = poolsResponse.map(p => p.data)
        set_polls(poolObj)
    }

    const onChange = (currentSlide) => {
        console.log(currentSlide);
    };

    const goNext = () => {

        if (ref.current !== null && ref.current.swiper !== null) {
            sendPollAnswer()
            ref.current.swiper.slideNext();
            set_currentSelected({})
            set_currentDesc("")
            console.log(ref.current.swiper.activeIndex)
            console.log("page : ",polls.length === ref.current.swiper.activeIndex)
        }
    };

    const goPrev = () => {
        console.log("dones : ",donePolls)
        if (ref.current !== null && ref.current.swiper !== null) {
            ref.current.swiper.slidePrev();
            set_currentSelected({})
            set_currentDesc("")
            console.log(ref.current.swiper.activeIndex)

        }
    };

    const [donePolls,set_donePolls] = useState([])
    const [currentSelected,set_currentSelected] = useState({})
    const [currentDesc,set_currentDesc] = useState("")

    const checkLastSlide = ()=>{
        if(ref.current){
            return polls.length === ref.current.swiper.activeIndex
        }
    }

    const selected = (poll)=>{
        console.log("current : ",poll)
        set_currentSelected(poll)
    }

    const sendPollAnswer = async ()=>{
        console.log("current Slide : ",ref.current.swiper.activeIndex);
        console.log("current Slide : ",currentSelected);
        console.log("current Slide : ",currentDesc);
        let currentPoll = polls[ref.current.swiper.activeIndex]
        if(currentSelected.uid){
            if(currentPoll.uid){
                let find = donePolls.find(d=>d.uid===currentPoll.uid);
                if(!find)
                    set_donePolls([...donePolls,currentPoll]);
            }
        }

        if(currentPoll && currentSelected.uid){
            const  obj = {
                item_uid: currentSelected.uid,
                polled_object_uid: "",
                des: currentDesc
            }

            try{
                const res = await pollAnswer_api(currentPoll.uid,obj)
            }catch (e) {
                console.log(e)
            }
         }

    }

    return (
        <div style={{margin: "20px 16px 0 16px"}}>
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            <div className="poll-content" >
                {polls && polls.length>0? <SwiperId ref={ref} {...imageParamss}>

                    {polls.map(p => {
                        return (
                            <div className="swiper-card-container">
                                {!p.type?<PollSlide donePolls={donePolls} p={p} select={selected}/>:null}
                                {p.type==="star"?<PollStarSlide donePolls={donePolls} p={p} select={selected}/>:null}
                                {p.type==="smile"?<PollSlide donePolls={donePolls} p={p} select={selected}/>:null}
                            </div>
                        )
                    })}
                    <div className="swiper-card-container">
                        <PollLastSlide donePolls={donePolls}  select={selected}/>
                    </div>
                </SwiperId>:null}

                <div className="poll-desc">
                    {!checkLastSlide()?<textarea
                        value={currentDesc}
                        onChange={(e)=>{set_currentDesc(e.target.value)}}
                        name="" id="" cols="30" rows="2" placeholder="توضیحات">
                </textarea>:null}
                </div>

                <div className="poll-handles">
                    <span className="poll-handle" onClick={goPrev}>قبلی</span>
                    {!checkLastSlide()?<span className="poll-handle" onClick={goNext}>بعدی</span>:null}
                </div>
            </div>
        </div>
    )
}

export default PollSec
